import { render, staticRenderFns } from "./plain.vue?vue&type=template&id=047bfe00&scoped=true&lang=pug"
import script from "./plain.vue?vue&type=script&lang=js"
export * from "./plain.vue?vue&type=script&lang=js"
import style0 from "./plain.vue?vue&type=style&index=0&id=047bfe00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047bfe00",
  null
  
)

export default component.exports